import { render, staticRenderFns } from "./AlarmsAccordion.vue?vue&type=template&id=08189535&scoped=true&"
import script from "./AlarmsAccordion.vue?vue&type=script&lang=js&"
export * from "./AlarmsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./AlarmsAccordion.vue?vue&type=style&index=0&id=08189535&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08189535",
  null
  
)

export default component.exports